/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RailTagContainer_tradePhoto = {
    readonly tags: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly " $fragmentRefs": FragmentRefs<"RailTag_tag">;
    } | null> | null;
    readonly " $refType": "RailTagContainer_tradePhoto";
};
export type RailTagContainer_tradePhoto$data = RailTagContainer_tradePhoto;
export type RailTagContainer_tradePhoto$key = {
    readonly " $data"?: RailTagContainer_tradePhoto$data;
    readonly " $fragmentRefs": FragmentRefs<"RailTagContainer_tradePhoto">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "RailTagContainer_tradePhoto",
  "type": "TradePhoto",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tags",
      "storageKey": null,
      "args": null,
      "concreteType": "TradePhotoTag",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "RailTag_tag",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '954a00d7ee70a19646ea154ca2bcb108';
export default node;
